<template>
  <div class="input-group daypickr">
    <q-btn flat round dense icon="chevron_left" @click="datepickerDec" class="noprint"></q-btn>
    <flat-pickr
      :modelValue="displayDate"
      @on-change="flatdateChanged"
      :config="config"
      placeholder="Select date"
      name="day"
    ></flat-pickr>
    <q-btn flat round dense icon="chevron_right" @click="datepickerAdd" class="noprint"></q-btn>
  </div>
</template>
<script lang="ts">
import { Emit, Model, Options, Prop, Vue } from "vue-property-decorator";
import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Danish } from "flatpickr/dist/l10n/da.js";
import { isSameDay, addDays } from "date-fns";
import i18n from "../i18n";

@Options({ components: { "flat-pickr": VueFlatPickr } })
export default class IstToolbarDate extends Vue {
  name = "IstToolbarDate";
  displayDate: Date = new Date();

  @Prop({ default: null, type: [Date] })
  readonly modelValue!: Date;
  @Prop()
  disabled = false;

  config: any = {
    week: { weekNumbers: true },
    wrap: true, // set wrap to true only when using 'input-group'
    altFormat: "d-m-Y ( " + i18n.global.t("actualPlan.weekescaped").toString() + " W )",
    altInput: true,
    dateFormat: "d-m-Y",
    weekNumbers: true,
    plugins: [],
    locale: Danish
  };

  mounted() {
    this.displayDate = this.modelValue || new Date();

    this.config = {
      wrap: true, // set wrap to true only when using 'input-group'
      altFormat: "d-m-Y ( " + i18n.global.t("actualPlan.weekescaped").toString() + " W )",
      altInput: true,
      dateFormat: "d-m-Y",
      weekNumbers: true,
      plugins: [],
      locale: Danish
    };
  }

  @Emit("change")
  @Emit("input")
  @Emit("update:modelValue")
  dateChanged(date: Date) {
    this.$emit("change", date);
    this.$emit("input", date);
    this.$emit("update:modelValue", date);
    return date;
  }

  datepickerChange(e, a, b) {
    if (!isSameDay(this.displayDate, e[0])) {
      this.displayDate = e[0];
      this.dateChanged(e[0]);
    }
  }

  public flatdateChanged(date: Date[]) {
    //this.$emit("change", date);
    this.dateChanged(date[0]);
  }

  datepickerAdd() {
    this.displayDate = addDays(this.modelValue, 1);
    this.dateChanged(this.displayDate);
  }
  datepickerDec() {
    this.displayDate = addDays(this.modelValue, -1);
    this.dateChanged(this.displayDate);
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/variables";

.daypickr {
  :deep(.flatpickr-input) {
    color: $ist-blue !important;
    border: none;
    text-align: center;
    cursor: pointer;
  }
}

.daypickr {
  :deep(.form-control) {
    color: $ist-blue !important;
    border: none;
    text-align: center;
    cursor: pointer;
  }
}
</style>
